<template>
  <div class="asset-box">
    <div
      class="asset-box__main"
      :class="isModal ? 'asset-box__main--short' : ''"
    >
      <div class="asset-box__top">
        <div class="content-left">
          <button
            type="button"
            class="btn btn-outline-dark m-1"
            :class="{ active: selectedCategory === '' }"
            @click="setCategory()"
            :disabled="isCategoryLocked && selectedCategory !== ''"
          >
            View All
          </button>
          <button
            v-for="(cat, key) in assetCategories"
            :key="key"
            type="button"
            class="btn btn-outline-dark text-capitalize m-1"
            :class="{ active: selectedCategory === key }"
            @click="setCategory(key)"
            :disabled="isCategoryLocked && selectedCategory !== key"
          >
            {{ cat }}
          </button>
        </div>

        <input
          ref="inputFile"
          @change="onAssetChange"
          type="file"
          style="display: none;"
        />
      </div>

      <div class="asset-box__content" v-click-outside="deselectAsset">
        <div
          v-for="asset in assetsCategorized[this.selectedCategory] || assets"
          ref="assetWrapper"
          :key="asset._id"
          class="asset-wrapper"
          :style="'height:' + assetDimensions.height + 'px'"
          @click.stop="onAssetClick($event, asset)"
        >
          <div
            class="asset"
            :class="selectedAsset._id == asset._id ? 'selected' : ''"
          >
            <img :src="`${$store.state.assetsPath}${asset.thumbPath}`" :alt="asset.description" />
          </div>
        </div>

        <p v-if="assets.length === 0">No assets found</p>

        <modal-edit-box
          :isVisible="this.selectedAsset.path && !this.isModal"
          :isArrowVisible="false"
          :xPos="this.selectedAsset.xPos"
          :yPos="this.selectedAsset.yPos"
          @remove="removeAsset"
          @update="editAsset"
        >
          <fieldset slot="input" class="form-group form-group--sm">
            <input
              v-model="selectedAsset.description"
              type="text"
              class="form-control form-control-lg"
              placeholder="label"
            />
          </fieldset>
        </modal-edit-box>
      </div>

      <div v-if="isModal || this.selectedCategory" class="asset-box__slot">
        <button
          v-if="isModal"
          type="button"
          class="btn btn-primary"
          :disabled="!selectedAsset._id"
          @click="attachTo"
        >
          <i class="fa fa-paperclip" aria-hidden="true"></i> Attach
        </button>
        <button
          v-if="isModal"
          type="button"
          class="btn btn-outline-danger ml-2"
          @click="removeAttachment"
        >
          <i class="fa fa-unlink" aria-hidden="true"></i> Remove Attachment
        </button>
        <span class="ml-auto">
          <fa v-if="isUploading" :icon="['fad', 'spinner-third']" class="loading-spinner mr-2"></fa>
        </span>
        <button 
          v-if="this.selectedCategory" 
          type="button" 
          class="btn btn-success" 
          @click="onBrowseClick"
          :disabled="isUploading"
        >
          <i class="fa fa-upload" aria-hidden="true"></i> Upload
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_ASSETS, ASSET_DELETE, ASSET_UPLOAD, ASSET_EDIT } from "@/store/actions.type";
import _ from "lodash";

export default {
  name: "asset-library",

  data() {
    return {
      assetCategories: {
        minimapImage: "Minimap Image",
        pageBackground: "Page Background",
        pageSidebarImage: "Page Sidebar",
        restMedia: "Rest Media",
        tagImage: "Tag Image",
        misc: "Misc"
      },

      assetDimensions: {
        height: 0,
        width: 0
      },

      assetToUpload: {
        file: null,
        category: "",
        description: ""
      },

      isCategoryLocked: this.initialLockedCategory,
      isUploading: false,
      selectedAsset: {},
      selectedCategory: this.initialCategory
    };
  },

  props: {
    initialCategory: "",
    initialLockedCategory: false
  },

  computed: {
    ...mapGetters(["assets"]),

    assetsCategorized() {
      let assetsCategorized = {};

      // loop through each valid category
      for (const cat in this.assetCategories) {
        let catArray = [];

        // loop through each asset
        this.assets.forEach(asset => {
          if (asset.category === cat) {
            catArray.push(asset);
          }
        });

        // add category array to object
        assetsCategorized = { ...assetsCategorized, [cat]: catArray };
      }

      return assetsCategorized;
    },

    isModal() {
      return ["assets"].indexOf(this.$route.name) === -1;
    }
  },

  created() {
    window.addEventListener("resize", _.throttle(this.getAssetDimensions, 150));
  },

  mounted() {
    this.$store
      .dispatch(FETCH_ASSETS)
      .then(res => {
        if (res.length !== 0) {
          this.getAssetDimensions();
        }
      })
      .catch(err => {
        this.$notify({
          message: "Error retrieving assets - " + err,
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        });
      });
  },

  updated() {
    this.getAssetDimensions();
  },

  destroyed() {
    window.removeEventListener("resize", this.getAssetDimensions);
  },

  methods: {
    getAssetDimensions() {
      if (this.$refs.assetWrapper && this.$refs.assetWrapper.length > 0) {
        this.assetDimensions.width = this.$refs.assetWrapper[0].clientWidth;
        this.assetDimensions.height =
          this.$refs.assetWrapper[0].clientWidth * 0.66;
      }
    },

    onBrowseClick() {
      this.$refs.inputFile.click();
    },

    onAssetChange() {
      this.assetToUpload.file = this.$refs.inputFile.files[0];
      this.assetToUpload.category = this.selectedCategory;
      this.assetToUpload.description = this.$refs.inputFile.files[0].name;

      let context = this;

      this.onAssetUpload();
    },

    onAssetUpload() {
      this.isUploading = true
      this.$store
        .dispatch(ASSET_UPLOAD, this.assetToUpload)
        .then(res => {
          setTimeout(() => {
            this.$store.dispatch(FETCH_ASSETS)
            this.isUploading = false
          }, 1000)
        })
        .catch(err => {
          this.isUploading = false
        });
    },

    setCategory(cat = "") {
      this.selectedCategory = cat;
    },

    onAssetClick(event, asset) {
      const modalWidth = 125;
      const modalHeight = 64.5;
      const clickedElement = event.target;
      const height = clickedElement.getBoundingClientRect().height;
      const width = clickedElement.getBoundingClientRect().width;

      let modalLeft = clickedElement.offsetLeft - modalWidth + width / 2;
      let modalTop = clickedElement.offsetTop + modalHeight;

      this.selectedAsset = asset;
      this.selectedAsset.xPos = modalLeft;
      this.selectedAsset.yPos = modalTop;
    },

    deselectAsset() {
      this.selectedAsset = {};
    },

    editAsset() {
      let assetToEdit = _.find(this.assets, asset => {
        return asset._id == this.selectedAsset._id;
      });

      assetToEdit.description = this.selectedAsset.description;

      this.$store
        .dispatch(ASSET_EDIT, this.selectedAsset)
        .then(res => {
          if (res.status === 200) {
            this.$notify({
              message: "Update successful",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success"
            });
          } else {
            this.$notify({
              message: "Update failed - " + res.statusText,
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          }
        })
        .catch(err => {
          this.$notify({
            message: "Update failed - " + err,
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "danger"
          });
        });

      this.deselectAsset();
    },

    removeAsset() {
      this.$store
        .dispatch(ASSET_DELETE, this.selectedAsset)
        .then(res => {
          this.$store.dispatch(FETCH_ASSETS)
          this.deselectAsset()
          console.log("Res", res)
        })
        .catch(err => {
          console.log("Err", err)
        })

    },

    attachTo() {
      this.$emit("attachTo", this.selectedCategory, this.selectedAsset);
      this.$parent.closeModal();
    },

    removeAttachment() {
      this.$emit("attachTo", this.selectedCategory, { path: "", thumbPath: "" });
      this.$parent.closeModal();
    }
  }
};
</script>
<style lang="scss">
.asset-box {
  display: flex;
  flex-direction: row;
  position: relative;

  &__main {
    display: flex;
    flex-direction: column;
    width: 100%;

    &--short {
      max-height: 670px;
    }
  }

  &__top {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: space-between;
    height: auto;
    padding: 10px 20px;
    width: 100%;

    .content-left {
      display: flex;
      flex-grow: 1;
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  &__content {
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    max-height: 800px;
    overflow: auto;
    padding: 10px;
    position: relative;
    width: 100%;

    .asset-wrapper {
      height: 250px;
      width: 100%;
      padding: 6px;
      user-select: none;

      @media (min-width: 980px) {
        width: calc(100% / 2);
      }

      @media (min-width: 1480px) {
        width: calc(100% / 3);
      }

      @media (min-width: 1880px) {
        width: calc(100% / 4);
      }

      .asset {
        border: 4px solid #fff;
        cursor: pointer;
        height: 100%;
        overflow: hidden;
        transform: scale(1);
        width: 100%;

        &:hover {
          img {
            opacity: 1;
            transform: scale(1.05);
          }
        }

        &.selected {
          border: 4px dashed #000;

          img {
            opacity: 1;
            transform: scale(1.05);
          }
        }

        img {
          backface-visibility: hidden;
          height: 100%;
          object-fit: cover;
          opacity: 0.8;
          pointer-events: none;
          transform: scale(1);
          transition: all 500ms cubic-bezier(0.075, 0.82, 0.165, 1);
          width: 100%;
        }
      }
    }
  }

  &__slot {
    display: flex;
    flex-shrink: 0;
    padding: 20px;
  }

  &__side-panel {
    background: #888;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    text-align: center;
    width: 200px;

    .cat-block {
      align-items: center;
      background: #666;
      color: #fff;
      display: flex;
      font-size: 16px;
      font-weight: 500;
      height: 80px;
      justify-content: center;
      text-transform: uppercase;
      width: 100%;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        margin: 20px 0;
      }
    }
  }

  .cat-title {
    font-size: 18px;
    padding: 25px 0 10px;
  }
}

.loading-spinner {
  animation: spin 1s infinite;
  color: #28a745;
  font-size: 24px;
  vertical-align: -.6em;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} 
</style>
